export default __webpack_public_path__ + "static/media/banner9en.50bd7a62.png";